import { store } from '../redux/store'
import { fold as foldContactFloating, toggle as toggleContactFloating } from '../redux/contact-floating-slice'
import { open as openContactFormModal } from '../redux/contact-form-modal-slice'

/* Elements */
let wrapperEl
let buttonToOpenEl
let contentEl
let buttonConsultenos

/* State vars */
let unfolded = false;

const onDomContentLoaded = (event) => {
    /* Get elemnts */
    wrapperEl = document.querySelector('.partial-contact-floating')
    if (wrapperEl === null) return
    buttonToOpenEl = wrapperEl.querySelector('.button-to-open')
    contentEl = wrapperEl.querySelector('.content')
    buttonConsultenos = wrapperEl.querySelector('.button-consultenos')

    /* Define events */
    buttonToOpenEl.addEventListener('click', onButtonToOpenClick)
    contentEl.addEventListener('click', onContentClick)
    buttonConsultenos.addEventListener('click', onButtonConsultenosClick)

    /* Redux store */
    store.subscribe(onStoreChange)

    /* Activate */
    wrapperEl.classList.add('activated')
}

const onButtonToOpenClick = (event) => {
    event.stopPropagation()
    store.dispatch(toggleContactFloating())
}

/* On content click it folds, assuming some action has been done. It would fold
 * anyway if we just don't stop propagation, because a click outside fodls it,
 * but let it that here in case we need to control it. */
const onContentClick = (event) => {
    event.stopPropagation()
    store.dispatch(foldContactFloating())
}

const onButtonConsultenosClick = (event) => {
    store.dispatch(openContactFormModal())
}

const onStoreChange = () => {
    const state = store.getState().contactFloating;
    if (state.unfolded !== unfolded) {
        unfolded = state.unfolded
        if (unfolded) {
            wrapperEl.classList.add('unfolded')
        } else {
            wrapperEl.classList.remove('unfolded')
        }
    }
}

document.addEventListener('DOMContentLoaded', onDomContentLoaded)
